import { useMutation } from "@tanstack/react-query";
import { z } from "zod";
import { apiUrls } from "../helpers/apiUrls";
import { useAxiosPrivate } from "../hooks/useAxiosPrivate";

const SendEmailRequestSchema = z.object({
    customers: z.array(z.string().uuid()).min(1),
    body: z.string().min(1),
    subject: z.string().min(1),
});

export const mailSenderService = {
    sendEmail: async (axios, data) => {
        return await axios.post(apiUrls.mailSender, data).then((response) => response.data);
    },
};

export const useSendEmail = (options = {}) => {
    const axiosPriv = useAxiosPrivate();
    return useMutation({
        ...options,
        mutationFn: (data) => mailSenderService.sendEmail(axiosPriv, data),
    });
};
